import UILabel from "components/ui/UILabel";
import { Theme } from "styled";
import styled from "styled-components";

export const Wrapper = styled.div`
  position: relative;

  display: flex;
  flex-direction: column;
  gap: 48px;
`;

export const Header = styled.div`
  display: flex;
  flex-direction: column;
  gap: 8px;
  align-items: flex-start;

  text-align: left;
`;

export const Subheading = styled(UILabel.Large)`
  color: color-mix(
    in srgb,
    ${(props) => props.theme.colors.text} 70%,
    ${(props) => props.theme.colors.uiBackground}
  );
`;

export const ListItem = styled.li`
  display: flex;
  width: 100%;
  gap: 16px;
  align-items: flex-start;
`;

const getIconStyles = (props: { $icon: string; theme: Theme }) => {
  switch (props.$icon) {
    case "plus":
      return `
        background: ${props.theme.colors.accent};
        color: ${props.theme.reverseColors.accent};
      `;
    case "minus":
      return `
        background: ${props.theme.colors.secondary};
        color: ${props.theme.reverseColors.secondary};
      `;
    default:
      return `
        background: ${props.theme.colors.primary};
        color: ${props.theme.reverseColors.primary};
      `;
  }
};

export const IconWrapper = styled.div<{ $icon: string }>`
  display: flex;
  align-items: center;
  justify-content: center;
  flex: 0 0 auto;
  width: 48px;
  height: 48px;

  background: ${(props) => props.theme.colors.accent};
  border-radius: 9999px;

  ${getIconStyles};
`;

export const ItemText = styled.div`
  display: flex;
  flex-direction: column;
  gap: 4px;
  flex: 1 1 auto;
  align-items: flex-start;
  padding-top: 4px;

  text-align: left;
`;

export const ItemBody = styled.div`
  display: flex;
  flex-direction: column;
  gap: 16px;
`;

export const List = styled.ul`
  display: flex;
  flex-direction: column;
  gap: 24px;
  width: 100%;
  padding: 0;
  margin: 0;

  list-style-type: none;
`;

export const Divider = styled.hr`
  width: 100%;
  border: none;
  border-top: 1px solid ${(props) => props.theme.colors.primary}40;
  margin: 12px 0;
`;
